import React, { Component } from "react";
import { View } from "react-native";
import { translate } from "react-i18next";

import Text from "components/StyledText";
import ViewScroll from "components/ViewScroll";
import Header from "components/Header";

import * as x from "styles/css";

class Notfound extends Component {
	static navigationOptions = {
		header: null,
	};
	static notFoundPage = true;

	render() {
		const { t } = this.props;

		return (
			<ViewScroll>
				<View style={[x.d.flex, x.justifyContent.center]}>
					<Header style={{ textAlign: "center" }}>
						{t("notFound.title")}
					</Header>
					<Text style={{ textAlign: "center" }} help>
						{t("notFound.help")}
					</Text>
				</View>
			</ViewScroll>
		);
	}
}

export default translate()(Notfound);



// WEBPACK FOOTER //
// ./src/views/Notfound/index.js